export default __webpack_public_path__ + "static/media/8.25c9a1b4.png";